import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { pricing_plan_data, user_add_to_cart } from '../api/Product';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

const PageMainBanner = ({ heading, title, para, image }) => {
      const navigate = useNavigate();
      const [get_pricing_list, set_Pricing_List] = useState([])
      // <-------- add to cart ------------>
      const handle_add_to_cart = async (data) => {
            try {
                  const formData = new FormData();
                  formData.append("product_id", get_pricing_list?.id);
                  formData.append("quantity", "1");
                  formData.append("order_type", "product");
                  // <---------- User Authentciation token's ------------>
                  const token = localStorage.getItem("token");
                  const headers = {
                        "Authorization": `Bearer ${token}`
                  };
                  const response = await user_add_to_cart(headers, formData);
                  if (response?.data?.status == "200") {
                        // navigate("/checkout", { state: data });
                        navigate("/cart");
                  }
                  else if (response?.response?.data?.status == "401") {
                        toast.error("Please log in to access this page.")
                        setTimeout(() => {
                              navigate("/login")
                        }, 2000)
                  }
                  console.log("response", response)
            }
            catch (error) {
                  console.log("error", error)
            }
      }
      useEffect(() => {
            const handle_pricing_plan_data = async () => {
                  try {
                        const response = await pricing_plan_data();
                        set_Pricing_List(response?.data?.pricing_plans && response?.data?.pricing_plans[0]);
                  }
                  catch (error) {
                        console.log("error", error)
                  }
            }
            handle_pricing_plan_data();
      }, [])
      return (
            <div className="relative">
                  {/* <-------- ToastContainer ------------> */}
                  <ToastContainer style={{ marginTop: "120px" }} />
                  <div className="absolute inset-0 -z-0">
                        <div className="absolute inset-0 bg-gradient-to-b from-black via-[#000000] to-black" />
                        <div className="absolute inset-0 bg-[linear-gradient(rgba(239,68,68,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(239,68,68,0.02)_1px,transparent_1px)]" style={{ backgroundSize: '32px 32px' }} />
                  </div>
                  <section className="relative">
                        <div className="relative isolate overflow-hidden">
                              <div className="absolute inset-0 -z-10">
                                    <div className="absolute inset-0 bg-gradient-to-b from-black via-[#000000] to-black">
                                    </div>
                                    <div className="absolute inset-0 bg-[linear-gradient(rgba(255,0,0,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,0,0,0.03)_1px,transparent_1px)]" style={{ backgroundSize: '64px 64px' }} />
                                    <div className="absolute -left-[40%] -top-[50%] w-[80%] h-[100%] rounded-full bg-gradient-to-r from-blue-900/30 to-blue-600/20 blur-[128px] animate-slow-float">
                                    </div>
                                    <div className="absolute -right-[40%] -bottom-[50%] w-[80%] h-[100%] rounded-full bg-gradient-to-l from-blue-800/20 to-blue-700/20 blur-[128px] animate-slow-float-reverse">
                                    </div>
                              </div>
                              <div className="relative mx-auto max-w-7xl px-6 py-10 md:py-24 sm:py-32 lg:px-8 lg:py-40">
                                    <div className="flex flex-col lg:flex-row items-center gap-16">
                                          <div className="flex-1 text-center text-md-start text-lg-start">
                                                <div className="inline-flex items-center px-4 py-2 rounded-full bg-blue-950 border-1 border-blue-800/30 mb-8">
                                                      <span className="text-sm font-medium text-blue-400">
                                                            {heading} </span>
                                                </div>
                                                <h1 className="text-3xl font-medium tracking-tight text-white sm:text-6xl">
                                                      {/* <span className>{title1} </span> */}
                                                      <span className="mt-2 bg-gradient-to-r from-blue-700 to-blue-500 bg-clip-text text-transparent">
                                                            {title}</span>
                                                </h1>
                                                <p className="mt-6 text-lg leading-8 text-gray-300 max-w-xl">{para}</p>
                                                {/* {heading !== "Domain" && heading !== "Contact Support" && <button 
                                               
                                                ><div className="mt-10 flex flex-col sm:flex-row gap-4 lg:justify-start justify-center"><span className="rounded-lg bg-gradient-to-r from-blue-800 to-blue-600 px-6 py-3.5 text-sm font-semibold text-white shadow-sm hover:from-blue-700 hover:to-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 transition-all duration-200 text-center">
                                                      Get started </span>
                                                </div></button>}
                                                {
                                                      heading === "Contact Support" && <button 
                                                       className="mt-10 flex flex-col sm:flex-row gap-4 lg:justify-start justify-center"><span className="rounded-lg bg-gradient-to-r from-blue-800 to-blue-600 px-6 py-3.5 text-sm font-semibold text-white shadow-sm hover:from-blue-700 hover:to-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 transition-all duration-200 text-center">
                                                            Get started </span>
                                                      </button>
                                                } */}
                                          </div>
                                          <div className="flex-1 relative">
                                                <div className="relative mx-auto w-full max-w-[450px] animate-float">
                                                      <div className="absolute inset-0 bg-gradient-to-r from-blue-800 to-blue-600 rounded-2xl blur-xl opacity-20">
                                                      </div>
                                                      <div className="relative bg-gray-900/80 backdrop-blur-xl rounded-2xl border-1 border-blue-900/20 p-8 shadow-2xl">
                                                            <div className="space-y-6">
                                                                  <img className="zoom-in-zoom-out" src={image} alt="test" />
                                                            </div>
                                                      </div>
                                                </div>
                                          </div>
                                    </div>
                              </div>
                        </div>
                  </section >
            </div >

      )
}

export default PageMainBanner